import * as React from 'react';

const ReturnArrowChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="return-arrow-chunky_svg__eds-icon--return-arrow-chunky_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="return-arrow-chunky_svg__eds-icon--return-arrow-chunky_base"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18 7.8V11H8.7V7l-5 5 5 5v-3.9h11V7.8z"
        />
    </svg>
);

ReturnArrowChunkySvg.displayName = 'ReturnArrowChunkySvg';
export default ReturnArrowChunkySvg;
